import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e87e965"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h2", null, "count:" + _toDisplayString(_ctx.count), 1),
    _createElementVNode("button", {
      class: "anim",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.forward && _ctx.forward(...args)))
    }, "go next page"),
    _createElementVNode("button", {
      class: "anim2",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
    }, "go back")
  ]))
}